import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Relayout, RelayoutItem, RelayoutWrapper } from 'relayout'
import { connect } from 'react-redux'

import { promoCodeLoadPartnerCodes } from 'actions/promo-code'
import { getPromoCodes } from 'selectors/entities'
import PromoCodeList from 'components/promo-code-list'
import LoadingSpinner from 'components/loading-spinner'
import PromoCodeFormModal from 'components/promo-code-form-modal'

import styles from './promo-code-page.css'

export class PromoCodePage extends Component {

  componentWillMount() {
    this.props.promoCodeLoadPartnerCodes(this.props.partnerId)
  }

  render() {
    if (this.props.promoCodes === undefined) {
      return (<LoadingSpinner />)
    }

    return (
      <div className="page" styleName="page">
        <RelayoutWrapper from="md">
          <Relayout align="center">
            <RelayoutItem xl="10">
              <PromoCodeList listOfCodes={Object.values(this.props.promoCodes)} />
            </RelayoutItem>
          </Relayout>
        </RelayoutWrapper>
        <PromoCodeFormModal />
      </div>
    )
  }

}

PromoCodePage.propTypes = {
  promoCodeLoadPartnerCodes: PropTypes.func,
  promoCodes: PropTypes.object,
  partnerId: PropTypes.string,
}

const mapStateToProps = (state, ownProps) => {
  const { partnerId } = ownProps.params

  return {
    promoCodes: getPromoCodes(state),
    partnerId,
  }
}

const mapDispatchToProps = {
  promoCodeLoadPartnerCodes,
}

export default connect(mapStateToProps, mapDispatchToProps)(
  CSSModules(PromoCodePage, styles)
)



/** WEBPACK FOOTER **
 ** ./src/containers/promo-code-page/promo-code-page.js
 **/